import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/collection/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/collection/';

class CollectionService {

  getAvailableCollections(adminMode = false) {
    return axios.get(`${API_URL}all/${adminMode}`);
  }
  getAllPlayers() {
    return axios.get(`${API_URL}all/players`);
  }
  getCollectionById(collectionId) {
    return axios.get(API_URL + collectionId);
  }
  createCollection(collection) {
    collection.players = _.uniqBy(collection.players,'playerId');
    return axios.post(API_URL,collection);
  }
  updateCollection(collection) {
    return axios.put(API_URL,collection);
  }
  deleteCollection(collectionId) {
    return axios.delete(API_URL + collectionId);
  }
  addPlayerToCollection(playerId,collectionId){
    return axios.post(`${API_URL}${collectionId}/player/${playerId}`,null);
  }
  addPlayersToCollection(playersId,collectionId){
    playersId = _.uniq(playersId);
    return axios.post(`${API_URL}${collectionId}/player`,playersId);
  }
  deletePlayerFromCollection(playerId,collectionId){
    return axios.delete(`${API_URL}${collectionId}/player/${playerId}`);
  }
  switchPinnedCollection(collectionId, pinned){
    return axios.put(`${API_URL}${collectionId}/pinned/${pinned}`);
  }
}

export default new CollectionService();
